var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9.25C2.41421 9.25 2.75 9.58579 2.75 10V12.6667C2.75 12.8214 2.81146 12.9697 2.92085 13.0791C3.03025 13.1885 3.17862 13.25 3.33333 13.25H12.6667C12.8214 13.25 12.9697 13.1885 13.0791 13.0791C13.1885 12.9697 13.25 12.8214 13.25 12.6667V10C13.25 9.58579 13.5858 9.25 14 9.25C14.4142 9.25 14.75 9.58579 14.75 10V12.6667C14.75 13.2192 14.5305 13.7491 14.1398 14.1398C13.7491 14.5305 13.2192 14.75 12.6667 14.75H3.33333C2.7808 14.75 2.25089 14.5305 1.86019 14.1398C1.46949 13.7491 1.25 13.2192 1.25 12.6667V10C1.25 9.58579 1.58579 9.25 2 9.25Z",
    fill: "#002D5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25006 10C7.25006 10.4142 7.58585 10.75 8.00006 10.75C8.41427 10.75 8.75006 10.4142 8.75006 10V3.81068L10.803 5.86366C11.0959 6.15655 11.5708 6.15655 11.8637 5.86366C12.1566 5.57077 12.1566 5.09589 11.8637 4.803L8.53331 1.4726C8.52359 1.46278 8.51361 1.45323 8.50337 1.44395C8.43919 1.38576 8.36738 1.34067 8.29135 1.30867C8.20856 1.27374 8.11819 1.25325 8.02339 1.25036C8.01561 1.25012 8.00784 1.25 8.00006 1.25C7.98589 1.25 7.97181 1.25039 7.95784 1.25117C7.87709 1.25565 7.79975 1.2729 7.72781 1.30094C7.63377 1.33751 7.54563 1.39375 7.46971 1.46967L4.13638 4.803C3.84348 5.09589 3.84348 5.57077 4.13638 5.86366C4.42927 6.15655 4.90414 6.15655 5.19704 5.86366L7.25006 3.81064V10Z",
    fill: "#002D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b3fcf3ec46154461c6d6cc41d70b30cc.svg";
export { ForwardRef as ReactComponent };